import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import type { IObjectType } from '../../../stores/model/metamodel/object_type';

/**
 * Check if the model contains another object type with the same name as the
 * object type under test.
 */
class ObjectDuplicateCheck extends Check<IObjectType> {
  static description = 'Check for duplicate objects';

  check(): Report {
    this.report = new Report();
    if (hasDuplicateElementName(this.model.objectTypes, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        'Object with the same name found.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No objects with the same name found.',
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default ObjectDuplicateCheck;
